import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        「ダウンロード可能なデータがありませんでした。」と表示されCSVダウンロードができない場合、以下をご確認ください。
      </p>
    </div>
    <div>
      <p className={styles.heading}>▶ ダウンロードできるデータがない</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          生徒がストックデータを共有・提出していない場合、CSVはダウンロードできません。
        </li>
        <li className={styles.item}>
          生徒アカウントでGEAR拡張設定が「ON」になっていない可能性があります。
        </li>
      </ul>
    </div>
    <div>
      <p className={styles.heading}>▶ GEAR拡張設定の確認方法</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          学校管理画面［生徒を登録］→［生徒一括編集］
        </li>
        <li className={styles.item}>
          対象生徒の［GEAR拡張］にチェックを入れてください
          <br />※
          GEAR拡張機能を利用するには、GEAR有償機能のお申し込みが必要です。
        </li>
      </ul>
    </div>
  </div>
);

export const STUDENT_CSV_DOWNLOAD_UNAVAILABLE_FAQ: FaqCategoryItem = {
  id: "student-csv-download-unavailable-faq",
  question: "生徒一覧からCSVがダウンロードできない",
  Answer,
};
